import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { createSelector } from 'reselect';

const ProfileDropdown = () => {

  const profiledropdownData = createSelector(
    (state) => state.Profile,
    (user) => user?.user
  );

  const user = useSelector(profiledropdownData);

  const [userName, setUserName] = useState("");

useEffect(() => {
  const authUser = sessionStorage.getItem("authUser");

  if (!authUser) return;

  const obj = JSON.parse(authUser);

  const extractedName =
    obj?.user?.propertyName ||
    obj?.propertyName ||
    obj?.username ||
    "";

  setUserName(extractedName);
}, []);

  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <Dropdown
      isOpen={isProfileDropdown}
      toggle={toggleProfileDropdown}
      className="ms-sm-3 header-item topbar-user"
    >
      <DropdownToggle tag="button" type="button" className="btn">
        <span className="d-flex align-items-center">
          <img className="rounded-circle header-profile-user" src={avatar1} alt="Header Avatar" />
          <span className="text-start ms-xl-2">
            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
              {userName}
            </span>
            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
          Kitchen Duniya
            </span>
          </span>
        </span>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <h6 className="dropdown-header">Welcome {userName}!</h6>
        <DropdownItem className="p-0">
          <Link to="/logout" className="dropdown-item">
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle" data-key="t-logout">Logout</span>
          </Link>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;
